<!-- Modern Dashboard Header -->
<div class="dashboard-header" fxLayout="column" fxLayoutGap="20px">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
        <h1 class="dashboard-title">Platform Usage Report</h1>
        <mat-icon class="link" 
                  (click)="copyShareableUrl()" 
                  matTooltip="Copy shareable link to clipboard"
                  matTooltipPosition="below">
          share
        </mat-icon>
      </div>
      <h2 class="company-name">{{ selectedCompany?.name || selectedCompany?.code }}</h2>
    </div>
  </div>
  
  <div fxLayout="row" 
       fxLayout.lt-md="column" 
       fxLayoutAlign="end center" 
       fxLayoutAlign.lt-md="stretch start" 
       fxLayoutGap="16px" 
       fxLayoutGap.lt-md="12px" 
       style="margin-right: 0;">
    <!-- Period Selection -->
    <mat-form-field appearance="outline" 
                    class="period-selector"
                    fxFlex.lt-md="100">
      <mat-label>Select Period</mat-label>
      <mat-select [(value)]="usageSummaryType" (selectionChange)="setUsageSummaryType($event.value)">
        <mat-option [value]="usageSummaryTypes.Day">Daily View</mat-option>
        <mat-option [value]="usageSummaryTypes.Month">Monthly View</mat-option>
      </mat-select>
    </mat-form-field>
    
    <!-- Date Selection -->
    <mat-form-field appearance="outline" 
                    class="date-selector" 
                    fxFlex.lt-md="100"
                    *ngIf="usageSummaryType === usageSummaryTypes.Day">
      <mat-label>Select Date</mat-label>
      <input matInput 
             [matDatepicker]="dayPicker" 
             [(ngModel)]="dateFrom"
             [min]="minDate"
             [max]="maxDate"
             [matDatepickerFilter]="dateFilter"
             (ngModelChange)="loadData()"
             readonly>
      <mat-datepicker-toggle matSuffix [for]="dayPicker"></mat-datepicker-toggle>
      <mat-datepicker #dayPicker></mat-datepicker>
    </mat-form-field>
    
    <mat-form-field appearance="outline" 
                    class="date-selector" 
                    fxFlex.lt-md="100"
                    *ngIf="usageSummaryType === usageSummaryTypes.Month">
      <mat-label>Select Month</mat-label>
      <input matInput 
             [matDatepicker]="monthPicker" 
             [(ngModel)]="dateMonthFrom"
             [min]="minDate"
             [max]="maxDate"
             [matDatepickerFilter]="dateFilter"
             (ngModelChange)="loadData()"
             readonly>
      <mat-datepicker-toggle matSuffix [for]="monthPicker"></mat-datepicker-toggle>
      <mat-datepicker #monthPicker startView="multi-year" (monthSelected)="setMonthAndYear($event, monthPicker)"></mat-datepicker>
    </mat-form-field>
    
    <!-- Export Button -->
    <button mat-raised-button 
            color="primary" 
            fxFlex.lt-md="100"
            (click)="downloadCSV()" 
            style="margin-right: 0;">
      <mat-icon>download</mat-icon>
      Export
    </button>
  </div>
</div>

<!-- Dashboard Content -->
<div class="dashboard-content" 
     fxLayout="row" 
     fxLayout.lt-lg="column" 
     fxLayoutGap="16px" 
     fxLayoutGap.lt-lg="20px">
  <!-- Left Column: Charts -->
  <div fxFlex="70" fxLayout="column" fxLayoutGap="16px">
    <!-- Top Row Charts -->
    <div fxLayout="row" 
         fxLayout.lt-md="column" 
         fxLayoutGap="16px" 
         fxLayoutGap.lt-md="16px">
      <mat-card fxFlex="50" class="chart-card" *ngIf="chartCalloutsData.length > 0">
        <mat-card-header>
          <mat-card-title [style.color]="baseColorBlue">Product Callouts</mat-card-title>
          <mat-card-subtitle>Distribution of product callouts</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content fxLayout="row" fxLayoutGap="12px">
          <div fxFlex="60" fxLayout="column" fxLayoutAlign="center center">
            <canvas baseChart #chartCallout="base-chart"
              chartType="doughnut"
              [data]="chartCalloutsData"
              [labels]="chartCalloutsLabels"
              [colors]="chartCalloutsColors"
              [options]="chartOptions"
              (click)="onChartClick($event, 'callout')"
              [legend]="false">
            </canvas>
          </div>
          <div fxFlex="40" class="table-section" [style.--section-color]="baseColorBlue" *ngIf="currentUsageSummary">
            <h4 [style.color]="baseColorBlue">Callout Details</h4>
            <div class="data-row">
              <span class="data-label">Homes:</span>
              <span class="data-value">{{ currentUsageSummary.productCalloutsHomes || 0 }}</span>
            </div>
            <div class="data-row">
              <span class="data-label">Products:</span>
              <span class="data-value">{{ currentUsageSummary.productCalloutsProducts || 0 }}</span>
            </div>
            <div class="data-row highlight">
              <span class="data-label">Total Callouts:</span>
              <span class="data-value">{{ currentUsageSummary.productCallouts || 0 }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      
      <mat-card fxFlex="50" class="chart-card" *ngIf="chartRendersData.length > 0">
        <mat-card-header>
          <mat-card-title [style.color]="baseColorPink">Render Performance</mat-card-title>
          <mat-card-subtitle>Render time distribution</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content fxLayout="row" fxLayoutGap="12px">
          <div fxFlex="60" fxLayout="column" fxLayoutAlign="center center">
            <canvas baseChart #chartRender="base-chart"
              chartType="doughnut"
              [data]="chartRendersData"
              [labels]="chartRendersLabels"
              [colors]="chartRendersColors"
              [options]="chartOptions"
              (click)="onChartClick($event, 'render')"
              [legend]="false">
            </canvas>
          </div>
          <div fxFlex="40" class="table-section" [style.--section-color]="baseColorPink" *ngIf="currentUsageSummary">
            <h4 [style.color]="baseColorPink">Render Details</h4>
            <div class="data-row">
              <span class="data-label">Queue Time:</span>
              <span class="data-value">{{ getTimeDisplay(currentUsageSummary.renderQueueTime) }}</span>
            </div>
            <div class="data-row">
              <span class="data-label">Render Time:</span>
              <span class="data-value">{{ getTimeDisplay(currentUsageSummary.renderTime) }}</span>
            </div>
            <div class="data-row highlight">
              <span class="data-label">Total Requests:</span>
              <span class="data-value">{{ currentUsageSummary.renderRequests || 0 }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    
    <!-- Bottom Row Charts -->
    <div fxLayout="row" 
         fxLayout.lt-md="column" 
         fxLayoutGap="16px" 
         fxLayoutGap.lt-md="16px">
      <mat-card fxFlex="50" class="chart-card" *ngIf="chartViewsData.length > 0">
        <mat-card-header>
          <mat-card-title [style.color]="baseColorGreen">View Activity</mat-card-title>
          <mat-card-subtitle>Breakdown by view type</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content fxLayout="row" fxLayoutGap="12px">
          <div fxFlex="60" fxLayout="column" fxLayoutAlign="center center">
            <canvas baseChart #chartView="base-chart"
              chartType="doughnut"
              [data]="chartViewsData"
              [labels]="chartViewsLabels"
              [colors]="chartViewsColors"
              [options]="chartOptions"
              (click)="onChartClick($event, 'view')"
              [legend]="false">
            </canvas>
          </div>
          <div fxFlex="40" class="table-section" [style.--section-color]="baseColorGreen" *ngIf="currentUsageSummary">
            <h4 [style.color]="baseColorGreen">View Breakdown</h4>
            <div class="data-row">
              <span class="data-label">Facade:</span>
              <span class="data-value">{{ currentUsageSummary.viewFacadeRequests || 0 }}</span>
            </div>
            <div class="data-row">
              <span class="data-label">Home:</span>
              <span class="data-value">{{ currentUsageSummary.viewHomeRequests || 0 }}</span>
            </div>
            <div class="data-row">
              <span class="data-label">Room:</span>
              <span class="data-value">{{ currentUsageSummary.viewRoomRequests || 0 }}</span>
            </div>
            <div class="data-row">
              <span class="data-label">Plan:</span>
              <span class="data-value">{{ currentUsageSummary.viewPlanRequests || 0 }}</span>
            </div>
            <div class="data-row">
              <span class="data-label">Product:</span>
              <span class="data-value">{{ currentUsageSummary.viewProductRequests || 0 }}</span>
            </div>
            <div class="data-row">
              <span class="data-label">Render:</span>
              <span class="data-value">{{ currentUsageSummary.viewRenderRequests || 0 }}</span>
            </div>
            <div class="data-row">
              <span class="data-label">Vanity:</span>
              <span class="data-value">{{ currentUsageSummary.viewVanityRequests || 0 }}</span>
            </div>
            <div class="data-row">
              <span class="data-label">VR:</span>
              <span class="data-value">{{ currentUsageSummary.viewVirtualRealityRequests || 0 }}</span>
            </div>
            <div class="data-row">
              <span class="data-label">Connect:</span>
              <span class="data-value">{{ currentUsageSummary.viewConnectRequests || 0 }}</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      
      <mat-card fxFlex="50" class="chart-card" *ngIf="chartStorageData.length > 0">
        <mat-card-header>
          <mat-card-title [style.color]="baseColorOrange">Storage Usage</mat-card-title>
          <mat-card-subtitle>Storage consumption in GB</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content fxLayout="row" fxLayoutGap="12px">
          <div fxFlex="60" fxLayout="column" fxLayoutAlign="center center">
            <canvas baseChart #chartStorage="base-chart"
              chartType="doughnut"
              [data]="chartStorageData"
              [labels]="chartStorageLabels"
              [colors]="chartStorageColors"
              [options]="chartOptions"
              (click)="onChartClick($event, 'storage')"
              [legend]="false">
            </canvas>
          </div>
          <div fxFlex="40" class="table-section" [style.--section-color]="baseColorOrange" *ngIf="currentUsageSummary">
            <h4 [style.color]="baseColorOrange">Storage Details</h4>
            <div class="data-row">
              <span class="data-label">Consumed:</span>
              <span class="data-value">{{ convertKbToGb(currentUsageSummary.storageConsumed || 0) }}GB</span>
            </div>
            <div class="data-row highlight">
              <span class="data-label">Total Available:</span>
              <span class="data-value">{{ convertKbToGb(currentUsageSummary.storageConsumedTotal || 0) }}GB</span>
            </div>
            <div class="data-row">
              <span class="data-label">Usage Percentage:</span>
              <span class="data-value">{{ getStoragePercentage() }}%</span>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
  
  <!-- Right Column: Key Metrics -->
  <div fxFlex="30" 
       fxFlex.lt-lg="100" 
       fxLayout="column" 
       fxLayout.lt-lg="row wrap" 
       fxLayout.lt-md="column" 
       fxLayoutGap="12px" 
       fxLayoutGap.lt-lg="12px">
    <mat-card class="metric-card" 
              fxFlex.lt-lg="1 1 calc(20% - 12px)" 
              fxFlex.lt-md="1 1 calc(50% - 12px)" 
              fxFlex.lt-sm="100" 
              *ngIf="currentUsageSummary">
      <mat-card-content fxLayout="column" fxLayoutAlign="center center">
        <div class="metric-value" [style.color]="baseColorBlue">{{ currentUsageSummary.productCallouts || 0 }}</div>
        <div class="metric-label">Total Callouts</div>
        <div class="metric-subtitle">Product selections</div>
      </mat-card-content>
    </mat-card>
    
    <mat-card class="metric-card" 
              fxFlex.lt-lg="1 1 calc(20% - 12px)" 
              fxFlex.lt-md="1 1 calc(50% - 12px)" 
              fxFlex.lt-sm="100" 
              *ngIf="currentUsageSummary">
      <mat-card-content fxLayout="column" fxLayoutAlign="center center">
        <div class="metric-value" [style.color]="baseColorPink">{{ currentUsageSummary.renderRequests || 0 }}</div>
        <div class="metric-label">Render Requests</div>
        <div class="metric-subtitle">{{ getTimeDisplay(currentUsageSummary.renderTime) }} total time</div>
      </mat-card-content>
    </mat-card>
    
    <mat-card class="metric-card" 
              fxFlex.lt-lg="1 1 calc(20% - 12px)" 
              fxFlex.lt-md="1 1 calc(50% - 12px)" 
              fxFlex.lt-sm="100" 
              *ngIf="currentUsageSummary">
      <mat-card-content fxLayout="column" fxLayoutAlign="center center">
        <div class="metric-value" [style.color]="baseColorGreen">{{ getTotalViews() }}</div>
        <div class="metric-label">Total Views</div>
        <div class="metric-subtitle">All view types</div>
      </mat-card-content>
    </mat-card>
    
    <mat-card class="metric-card" 
              fxFlex.lt-lg="1 1 calc(20% - 12px)" 
              fxFlex.lt-md="1 1 calc(50% - 12px)" 
              fxFlex.lt-sm="100" 
              *ngIf="currentUsageSummary">
      <mat-card-content fxLayout="column" fxLayoutAlign="center center">
        <div class="metric-value" [style.color]="baseColorOrange">{{ convertKbToGb(currentUsageSummary.storageConsumed || 0) }}</div>
        <div class="metric-label">Storage Used (GB)</div>
        <div class="metric-subtitle">of {{ convertKbToGb(currentUsageSummary.storageConsumedTotal || 0) }}GB total</div>
      </mat-card-content>
    </mat-card>
    
    <mat-card class="metric-card" 
              fxFlex.lt-lg="1 1 calc(20% - 12px)" 
              fxFlex.lt-md="1 1 calc(50% - 12px)" 
              fxFlex.lt-sm="100">
      <mat-card-content fxLayout="column" fxLayoutAlign="center center">
        <div class="metric-value" style="color: #666;">{{ getDataPeriodLabel() }}</div>
        <div class="metric-label">Reporting Period</div>
        <div class="metric-subtitle">{{ getDataTimestamp() }}</div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
<!-- No Data State -->
<div class="no-data-state" *ngIf="filteredUsageSummaries.length === 0" fxLayout="column" fxLayoutAlign="center center">
  <mat-icon class="no-data-icon">assessment</mat-icon>
  <h3>No Usage Data Available</h3>
  <p>There is no platform usage data for the selected time period.</p>
  <p class="date-hint">Try selecting a different date or period.</p>
</div>
<!-- Table is now hidden as data is integrated with charts above -->